'use client';

import { defineMessage, defineMessages } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { BypassBlock } from '@packages/shared/src/ui/BypassBlock/BypassBlock';
import { Link } from '@packages/modules/src/Link/Link';

import { bypassBlockMessages } from '../messages';
import { useAppBanner } from './useAppBanner';

const appBannerMessages = defineMessages({
  title: {
    id: 'appbanner.title',
    defaultMessage: 'Unsere App',
  },
  description: { id: 'appbanner.description', defaultMessage: 'Kostenlos im Store' },
  action: { id: 'appbanner.action', defaultMessage: 'Jetzt anzeigen' },
  close: { id: 'appBanner.close', defaultMessage: 'Schließen' },
});

export const AppBanner = () => {
  const { isVisible, appUrl, formatMessage, handleClick, handleClose } = useAppBanner();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="bg-color-grey-light relative p-2" data-testid="app-banner">
      <BypassBlock
        skipScrollIntoView
        buttonText={formatMessage(bypassBlockMessages.bypassAppBanner)}
      >
        <Button
          variant="icon-only"
          className="absolute top-0.5 right-0.5 h-4"
          onClick={handleClose}
          aria-label={formatMessage(appBannerMessages.close)}
        >
          <div className="icon-emp-cancel" />
        </Button>
        <Link href={appUrl} onClick={handleClick} className="flex items-center gap-2 no-underline">
          <div className="bg-color-background-base flex rounded-r-[0.5rem]">
            <div className="icon-emp-app-icon h-[4rem] w-[4rem]" />
          </div>
          <div className="text-color-text-dark">
            <p>{formatMessage(appBannerMessages.title)}</p>
            <p className="font-bold">{formatMessage(appBannerMessages.description)}</p>
            <p className="font-bold">{formatMessage(appBannerMessages.action)}</p>
          </div>
        </Link>
      </BypassBlock>
    </div>
  );
};
